module.exports = __webpack_public_path__ + "img/2026_S.a109f1c6.png";